module.exports = __webpack_public_path__ + "img/alipay.91059970.png";